import { computed, reactive, watch } from '@vue/composition-api';

export default function errorHandling(store, filters) {
  const currentError = reactive({});

  const computedError = computed(() => store.getters['error/currentError']);

  watch(computedError, () => {
    currentError.value = computedError.value;
  });

  const getErrorTranslation = (translateFunction) => {
    if (currentError.value) {
      if (currentError.value.code === 'errors.app') {
        return currentError.value.msg;
      }

      let params = { message: currentError.value.msg };
      if (currentError.value.data) {
        params = { ...params, ...currentError.value.data };

        for (const key in currentError.value.data) {
          if (key.endsWith('_date')) {
            params[`${key}_formatted`] = filters.formatShortDateWithHour(currentError.value.data[key]);
            params[`${key}_formatted_time`] = filters.formatHour(currentError.value.data[key]);
            params[`${key}_formatted_date`] = filters.formatShortDate(currentError.value.data[key]);
          }
        }
      }
      return translateFunction.$t(currentError.value.code, params);
    }
  };

  const translateError = (translateFunction, i18nCode, error, extras = {}) => {
    if (!error) return '';

    let params = extras;
    if (error.data) {
      params = { ...params, ...error.data };

      for (const key in error.data) {
        if (key.endsWith('_date')) {
          params[`${key}_formatted`] = filters.formatShortDateWithHour(error.data[key]);
          params[`${key}_formatted_time`] = filters.formatHour(error.data[key]);
          params[`${key}_formatted_date`] = filters.formatShortDate(error.data[key]);
        }
      }
    }
    return translateFunction.$t(i18nCode, params);
  };

  const getGenericErrorMessage = (translateFunction, code) => {
    if (currentError.value) {
      return translateFunction.$t('errors.refresh_required', { code: code });
    }
  };

  return { currentError, getErrorTranslation, getGenericErrorMessage, translateError };
}
